// AI Generated Test
import { Component, OnInit } from '@angular/core';
import { PdfService } from '@client/app/services/entities/pdf/pdf.service';
import { LinksRepoService } from '@client/app/services/api/links-repo/links-repo.service';

@Component({
    selector: 'accessibility-dashboard-pdf',
    standalone: false,
    template: `
        <mon-panel-next header="{{ 'PDF Compliance Status' | translate }}" panelLeftClass="col-47"
                   subHeader="{{ 'PDF files that are reviewed or pending for accessibility' | translate}}">
            <panel-body>
                <mon-spinner [progress]="progress">
                    <div *ngIf="!loading" class="row pb-3">
                        <div class="col-24">
                            <accessibility-dashboard-pdf-doughnut type="internal"
                                                                  typeAsText="{{'Internal PDFs' | translate}}"
                                                                  [data]="internal">
                            </accessibility-dashboard-pdf-doughnut>
                        </div>
                        <div class="col-24">
                            <accessibility-dashboard-pdf-doughnut type="external"
                                                                  typeAsText="{{'External PDFs' | translate}}"
                                                                  [data]="external">
                            </accessibility-dashboard-pdf-doughnut>
                        </div>
                    </div>
                </mon-spinner>
            </panel-body>
        </mon-panel-next>
    `,
})
export class AccessibilityDashboardPdfComponent implements OnInit {
    internal: any = {
        total: 0,
        reviewed: 0,
        unreviewed: 0,
    };

    external: any = {
        total: 0,
        reviewed: 0,
        unreviewed: 0,
    };

    loading = true;
    progress: any;

    constructor (
        private pdfService: PdfService,
        private linksRepoService: LinksRepoService,
    ) {}

    ngOnInit (): void {
        const promises: any[] = [];
        promises.push(this.getInternal(true));
        promises.push(this.getInternal(false));
        promises.push(this.getExternal(true));
        promises.push(this.getExternal(false));

        this.progress = Promise.all(promises).then((values: any[]) => {
            this.internal.reviewed =
                values[1].total === '0' && values[0].total === '0' ? 1 : parseInt(values[0].total);
            this.internal.unreviewed = parseInt(values[1].total);
            this.internal.total = this.internal.unreviewed + this.internal.reviewed;

            this.external.reviewed =
                values[2].total === '0' && values[3].total === '0' ? 1 : parseInt(values[2].total);
            this.external.unreviewed = parseInt(values[3].total);
            this.external.total = this.external.unreviewed + this.external.reviewed;
            this.loading = false;
        }).catch(() => {
            // Handle error case similar to angular.noop
        });
    }

    private getInternal (review: boolean): Promise<any> {
        const params: any = {
            type: 'pdf',
            page_size: 1,
            page: 1,
            reviewed: review,
        };

        return this.pdfService.get(params);
    }

    private getExternal (review: boolean): Promise<any> {
        const params = {
            status: 'active',
            relation: 'external',
            type: 'pdf',
            page_size: 1,
            page: 1,
            accessibility_reviewed: review,
        };

        return this.linksRepoService.getAll(params);
    }
}
